import SuggestionItem from './SuggestionItem'

export const generateSuggestionItemsTransparent = (isIpadLandscape) => {
  return Array.from(Array.from({ length: isIpadLandscape ? 8 : 6 }).keys()).map(
    (key) => ({
      key,
      value: String(key),
      label: (
        <SuggestionItem
          isTransparent
          isIpadLandscape={isIpadLandscape}
          materialNumber={String(key)}
          name={String(key)}
        />
      ),
      disabled: true,
    }),
  )
}

export const generateSuggestionItemsLoading = (isIpadLandscape) => {
  return Array.from(Array.from({ length: isIpadLandscape ? 8 : 6 }).keys()).map(
    (key) => ({
      key,
      value: String(key),
      label: (
        <SuggestionItem
          isLoading
          isIpadLandscape={isIpadLandscape}
          materialNumber={String(key)}
          name={String(key)}
        />
      ),
      disabled: true,
    }),
  )
}
